import api from "app/api";

// Login user
const login = async (userData) => {
  try {
    const response = await api.post("api/login", userData);
    const roles = response.data?.roles || [];

    if (
      !roles.includes("ROLE_MAINTENANCE_SUPERVISOR") &&
      !roles.includes("ROLE_STORES") &&
      !roles.includes("ROLE_FINANCE") &&
      !roles.includes("ROLE_IT") &&
      !roles.includes("ROLE_SERVICE_TECHNICIAN")
    ) {
      throw Error("Access denied!");
    }

    if (response) {
      localStorage.setItem("user", JSON.stringify(response.data));
      localStorage.setItem("userToken", JSON.stringify(response.data.access_token));

      const isServiceTechnician = roles.includes("ROLE_SERVICE_TECHNICIAN");
      if (isServiceTechnician) {
        const asyncStorageResponse = await api.get("/serviceapi/readAsyncStorageValues");
        const asyncData = asyncStorageResponse?.data;
        const webAccessForTech = asyncData?.webAccessForTech;

        if (webAccessForTech === false || webAccessForTech === "false") {
          localStorage.removeItem("user");
          localStorage.removeItem("userToken");
          throw Error("Web access is disabled for service technicians. Please contact your administrator.");
        }
      }
    }

    return response;
  } catch (error) {
    if (error?.message) {
      console.log("error", error.message);
    }
    if (error?.response?.data?.message) {
      console.log("error", error.response.data.message);
    }
    throw error;
  }
};

// Logout user
const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("userToken");
};

const resetUserPassword = async (userData) => {
  try {
    const response = await api.post("serviceapi/resetUserPassword", userData);
    return response;
  } catch (error) {
    if (error.message) {
      console.log("error", error.message);
    }
    if (error.response?.data?.message) {
      console.log("error", error.response.data.message);
    }
    throw error; // Re-throw the error to handle it in the component
  }
};

const authService = {
  logout,
  login,
  resetUserPassword,
};

export default authService;
